<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-top-align`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a1 1 0 011-1h38a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V4zm20.647 5.253a1 1 0 00-1.338.069l-1.414 1.414L10.58 22.05a1 1 0 000 1.414l1.414 1.414a1 1 0 001.414 0l8.605-8.605v27.725a1 1 0 001 1h2a1 1 0 001-1V16.27l8.609 8.608a1 1 0 001.414 0l1.414-1.414a1 1 0 000-1.414L26.137 10.736l-1.414-1.414a1.008 1.008 0 00-.076-.069z"/></svg>
</template>
<script>

export default {
  name: 'IconTopAlign',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
